export default __webpack_public_path__ + "static/media/search-18-black.e68c07d6.svg";